import { injectAdTag } from "../lib/provideInjectors";
import { computed } from "vue";
import DraftKings from "../images/draft-kings.svg";
import WillHillHorizontal from "../images/william-hill-horizontal.svg";
import WillHillUS from "../images/william-hill-us.svg";

export function useBrand() {
  const adTagData = injectAdTag();
  const brand = computed(() => adTagData.value.brand);

  const operator = computed(() => {
    let assetUrl = "";
    // Hardcoding until we can pass the urls in the payload.
    // Inccluding the asset in the bundle so it gets requested through KeyCDN.

    switch (true) {
      case /draftkings/.test(adTagData.value.operator.key):
        assetUrl = DraftKings;
        break;
      case /william-hill-us/.test(adTagData.value.operator.key) &&
        brand.value._id === "5f47d8d2321248001aeb7816":
        assetUrl = WillHillHorizontal;
        break;
      case /william-hill-us/.test(adTagData.value.operator.key):
        assetUrl = WillHillUS;
        break;
      case /ceasers/.test(adTagData.value.operator.key):
        assetUrl =
          "https://cdn.fresh8.co/assets/evo-assets/operator-logos/draftkings/desktop-dark.svg";
        break;
    }
    return { ...adTagData.value.operator, assetUrl };
  });

  const fonts = computed(() => brand.value.fonts);
  const colors = computed(() => brand.value.colors);
  const buttons = computed(() => brand.value.buttons);

  const getColor = (colorKey: string) => colors.value?.[colorKey]?.color;

  const getFont = (fontKey: string) => ({
    fontFamily: fonts.value[fontKey].fontAsset.fontFamily,
    color: getColor(fonts.value[fontKey].color) || ""
  });

  const adTagSize = computed(() => adTagData.value.size);
  const responsive = computed(() => adTagData.value.responsive);
  const headerBranding = computed(() => brand.value.adTemplate.header);
  const marketBranding = computed(() => brand.value.adTemplate.market);
  const footerBranding = computed(() => brand.value?.adTemplate.footer);
  const adTemplateBranding = computed(() => ({
    backgroundColor: getColor(brand.value.adTemplate.backgroundColor),
    borderRadius: brand.value.adTemplate.borderRadius
  }));

  const getButton = (buttonKey: string) => {
    const button = buttons.value[buttonKey];

    function getActionColors(action) {
      return {
        color: getColor(action.color),
        backgroundColor: getColor(action.backgroundColor),
        borderColor: getColor(action.borderColor)
      };
    }

    return {
      ...button,
      primaryFont: getFont(button.primaryFont || ""),
      secondaryFont: getFont(button.secondaryFont || ""),
      backgroundColor: getColor(button.backgroundColor || ""),
      borderColor: getColor(button.borderColor || ""),
      hover: button?.actions.hover
        ? getActionColors(button.actions.hover)
        : undefined,
      active: button?.actions.active
        ? getActionColors(button.actions.active)
        : undefined
    };
  };

  return {
    getFont,
    getColor,
    getButton,
    adTagSize,
    responsive,
    operator,
    fonts,
    headerBranding,
    marketBranding,
    adTemplateBranding,
    footerBranding
  };
}
